import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// Импорты для компонента-источника
import React, { useEffect, useState } from 'react';
import { getWindow } from "../../../utils/window";
import { TopUpBalanceComponent } from "../Root/TopUpBalanceComponent";
import { TOPUP_PROPS_EVENT, TOPUP_PROPS_EVENT_REQUEST, TOPUP_PROPS_EVENT_RESPONSE } from "../constants";

/**
 * Компонент-источник для разделенного режима работы
 * Слушает события и рендерит компонент с полученными пропсами
 * Используется в отвязанном бандле для получения данных от основного приложения
 */
export var DecoupledTopUpBalanceSource = function DecoupledTopUpBalanceSource() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    _props = _useState2[0],
    setProps = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldRender = _useState4[0],
    setShouldRender = _useState4[1]; // This is needed because this component listens to props async

  useEffect(function () {
    var _getWindow;
    // Обработчик события с пропсами от компонента-цели
    var listener = function listener(e) {
      var props = e.detail;
      setProps(props);
      setShouldRender(true);
    };

    // Подписка на событие пополнения
    document.addEventListener(TOPUP_PROPS_EVENT_RESPONSE, listener);
    (_getWindow = getWindow()) === null || _getWindow === void 0 || _getWindow.document.dispatchEvent(new CustomEvent(TOPUP_PROPS_EVENT_REQUEST));

    // Отписка при размонтировании
    return function () {
      document.removeEventListener(TOPUP_PROPS_EVENT_RESPONSE, listener);
    };
  }, []);
  useEffect(function () {
    // Обработчик события с пропсами от компонента-цели
    var listener = function listener(e) {
      if (!shouldRender) return;
      var props = e.detail;
      setProps(props);
    };

    // Подписка на событие пополнения
    document.addEventListener(TOPUP_PROPS_EVENT, listener);

    // Отписка при размонтировании
    return function () {
      document.removeEventListener(TOPUP_PROPS_EVENT_RESPONSE, listener);
    };
  }, [shouldRender]);
  if (!shouldRender) return null;

  // Рендерим компонент с полученными пропсами
  return /*#__PURE__*/React.createElement(TopUpBalanceComponent, _extends({
    isOpen: false,
    setIsOpen: function setIsOpen() {}
  }, _props, {
    "data-t-id": "components-Decoupled"
  }));
};